import {
  addDays,
  fromUnixTime,
  isAfter,
  isBefore,
  isSameDay,
  parse,
} from "date-fns";

export default class TimeUtil {
  static convertTimestampInSecondsToDateString(timestamp: number) {
    const date = fromUnixTime(timestamp);
    return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
  }

  static convertDateToDateString(date: Date) {
    return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
  }

  static convertDateStringToDate(dateString?: string): Date | null {
    if (!dateString) {
      return null;
    }
    const [dayStr, monthStr, yearStr] = dateString ? dateString.split("-") : "";
    const day = dayStr?.length === 1 ? `0${dayStr}` : dayStr;
    const month = monthStr?.length === 1 ? `0${monthStr}` : monthStr;

    const formatString = "dd-MM-yyyy";

    return parse(`${day}-${month}-${yearStr}`, formatString, new Date());
  }

  static createFreePeriodExpiryDateString(now: Date): string {
    const expiryDate = addDays(now, 21);
    return `${expiryDate.getDate()}-${
      expiryDate.getMonth() + 1
    }-${expiryDate.getFullYear()}`;
  }

  static addDays(date: Date, days: number): Date {
    return addDays(date, days);
  }

  static isTodayOrBefore(date: Date, today: Date): boolean {
    return isSameDay(date, today) || isBefore(date, today);
  }

  static isAfter(date: Date, date2: Date): boolean {
    return isAfter(date, date2);
  }

  static formatDateStringToISODateString(
    date: string,
    hours: number,
    minutes = 0,
    seconds = 0
  ): string | undefined {
    if (!date) {
      return undefined;
    }
    const [dayStr, monthStr, yearStr] = date.split("-");

    const year = yearStr?.length ? Number(yearStr) : undefined;
    const monthIndex = monthStr?.length ? Number(monthStr) - 1 : undefined;
    const day = dayStr?.length ? Number(dayStr) : undefined;

    const dateObj =
      year !== undefined && monthIndex !== undefined && day !== undefined
        ? new Date(year, monthIndex, day, hours, minutes, seconds)
        : undefined;
    return dateObj ? dateObj.toISOString() : undefined;
  }

  static createExpiresAt(value?: string): Date | null {
    if (!value?.length) {
      return null;
    }
    const [dayStr, monthStr, yearStr] = value.split("-");
    const day = parseInt(dayStr, 10);
    const month = parseInt(monthStr, 10);
    const year = parseInt(yearStr, 10);

    const hasExpiryDate =
      day >= 1 && month >= 0 && year >= 2025
        ? new Date(year, month - 1, day)
        : null;
    hasExpiryDate?.setHours(23);

    return hasExpiryDate;
  }
}
